import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

export default function FAQ({ overline, title, items }) {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-mist py-20 md:py-28 border-t border-line" data-testid="faq">
      <div className="mx-auto max-w-4xl px-4 md:px-8">
        <Reveal>
          <Overline>{overline}</Overline>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.08]">
            {title}
          </h2>
        </Reveal>

        <div className="mt-12 space-y-3">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`rounded-2xl border bg-paper transition-colors ${isOpen ? "border-brand/40" : "border-line"}`}>
                <button
                  data-testid={`faq-item-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-start justify-between gap-6 p-5 md:p-6 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-base md:text-lg font-semibold tracking-tight pr-2">{item.q}</span>
                  <span className={`mt-0.5 shrink-0 h-8 w-8 rounded-full grid place-items-center transition-colors ${isOpen ? "bg-brand text-white" : "bg-mist text-ink"}`}>
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="px-5 md:px-6 pb-6 text-stone leading-relaxed">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
